import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

type Props = {
    status?: number
}

const getWording = (props: Props) => {
    switch (props.status) {
        case 429: // レート制限中
            return {
                errorMsgTitle: '申し訳ありません。',
                errorMsg: 'ご利用のIPアドレスから高頻度のアクセスが検出されたため、現在アクセスを制限しています。一定時間後に再度ご利用いただけます。'
            };
        default: // デフォルトメッセージ
            return {
                errorMsgTitle: '申し訳ありません。',
                errorMsg: 'お客様のテナントでは、現在この機能をご利用になれません。'
            };
    }
}

const Error = (props: Props) => {
    const wording = getWording(props);
    return (
        <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity='error'>
                <AlertTitle>{wording.errorMsgTitle}</AlertTitle>
                {wording.errorMsg}
            </Alert>
        </Stack>
    );
}

export default Error;